import * as React from "react";
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  ReferenceField,
  ShowButton,
} from "react-admin";
import DownloadCV from "./download-cv-button";

export const CandidatePollinationList = ({ ...props }) => (
  <List {...props} perPage={25} sort={{ field: "updated", order: "DESC" }}>
    <Datagrid bulkActionButtons={false} rowClick={false}>
      <ReferenceField
        source="candidateId"
        reference="candidates"
        label="First Name"
        link={false}
        sortable={false}
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        source="candidateId"
        reference="candidates"
        label="Last Name"
        link={false}
        sortable={false}
      >
        <TextField source="lastName" />
      </ReferenceField>
      <ReferenceField
        source="candidateId"
        reference="candidates"
        label="Email"
        link={false}
        sortable={false}
      >
        <EmailField source="email" />
      </ReferenceField>
      <ShowButton />
      <DownloadCV />
    </Datagrid>
  </List>
);
